import React, { useEffect, useState } from "react";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Box,
  DialogActions,
  DialogContent,
  Dialog,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMessage } from "../../context/message-context";
import { useSessionStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { styled } from "@mui/material/styles";
import apiRequest from "../../functions/api";
import { convertFromHTML, ContentState } from "draft-js";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import openFile from "../shared/functions/download";
import { API_BASE_URL } from "../../constants/apiConstants";
import axios from "axios";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import { useTheme } from "@mui/styles";
import { HtmlEditor } from "./HtmlEditor";
import { PushPin } from "@mui/icons-material";

function SchwarzesBrett() {
  const { t } = useTranslation();
  const [daten, SetDaten] = useState();
  const [showMeldung, setShowMeldung] = useState(null);
  const [neuigkeiten, setNeuigkeiten] = useState(() => {
    const stored = localStorage.getItem("SCHWARZES_BRETT");
    if (stored === null) return true;
    return stored === "true";
  });
  const [isMounted, setIsMounted] = useState(true);
  const { showErrorMessage } = useMessage();
  const [openedAccordion, setOpenedAccordion] = useState("");
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const theme = useTheme();
  const program = "BRETTL";
  const bg_color = theme.palette.mode === "dark" ? "#616161ff" : "#f0f0f0";
  const mandantText = theme.palette.mode === "dark" ? "lightgray" : "gray";

  const CustomTableCell = styled(TableCell)({
    borderBottom: "none",
    padding: "4px",
  });

  useEffect(() => {
    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    loadActive();
  }, []);

  useEffect(() => {
    localStorage.setItem("SCHWARZES_BRETT", String(neuigkeiten));
  }, [neuigkeiten]);

  useEffect(() => {
    const saved = localStorage.getItem("SCHWARZES_BRETT_NEWS");

    try {
      const parsed = JSON.parse(saved);
      SetDaten(parsed);
    } catch (err) {
      // Sicherster Weg um zu verhindern das wir bei einem leeren key abstürzen
    }
  }, []);

  const compareArrays = (arr1, arr2) => {
    if (!arr1) return false;
    if (!arr2) return false;
    if (arr1.length !== arr2.length) return false;

    const sortById = (arr) => [...arr].sort((a, b) => a.key - b.key);
    const sorted1 = sortById(arr1);
    const sorted2 = sortById(arr2);

    return sorted1.every((item, index) => {
      return JSON.stringify(item) == JSON.stringify(sorted2[index]);
    });
  };

  const loadActive = () => {
    const payload = {
      statement: "LADEN_AKTIV",
      program: program,
      alleLaden: 0,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };

    apiRequest("POST", "schwarzes_brett-anfrage", payload, headers, loadCb);
  };

  const loadCb = (response) => {
    if (!isMounted) return;
    const saved = localStorage.getItem("SCHWARZES_BRETT_NEWS");

    var newsChanged = false;
    try {
      newsChanged = compareArrays(response.data.items, JSON.parse(saved));
    } catch (err) {
      // Sicherster Weg um zu verhindern das wir bei einem leeren key abstürzen
    }

    if (!newsChanged) {
      setNeuigkeiten(true);
    }
    SetDaten(response.data.items);
    localStorage.setItem("SCHWARZES_BRETT_NEWS", JSON.stringify(response.data.items)); //Hier schreiben wir die aktuellen news einmal weg damit wir später den Vergleich ziehen können ob es etwas neues gibt
  };

  const openDatei = (event, file) => {
    event.stopPropagation();
    const payload = {
      ffe3_key: file,
      program: program,
      statement: "GET_FILE_DATA",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    axios
      .post(API_BASE_URL + "schwarzes_brett-anfrage", payload, { headers: headers, responseType: "blob" })
      .then((response) => {
        var fileName = response.headers["content-disposition"].match(/filename="?([^"]+)"?/)[1];
        var contentFile = response.data;
        openFile(fileName, contentFile);
      })
      .catch(function (error) {
        showErrorMessage("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut. Fehler: " + error);
      });
  };

  const closeMeldung = (event) => {
    event.stopPropagation();
    setShowMeldung(false);
  };

  const HtmlToText = ({ htmlText }) => {
    // const cleanHtmlContent = DOMPurify.sanitize(htmlContent); Brauchen wir eventuell nen HTML Pruifyer?

    const blocksFromHTML = convertFromHTML(htmlText);
    const contentState = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
    const plainText = contentState.getPlainText();

    return <Typography component="div">{plainText}</Typography>;
  };

  const accordionChange = (key) => {
    if (openedAccordion === key) {
      setOpenedAccordion("");
    } else {
      setOpenedAccordion(key);
    }
  };

  const shortText = (htmlText, maxLength) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, "text/html");
    const text = doc.body.textContent.trimEnd();

    return (
      <Box sx={{ paddingLeft: 1 }} display="flex" justifyContent="center" width="100%">
        <Box flex={1} display="flex">
          <Typography sx={{ paddingLeft: 1, paddingBottom: 1 }} variant="subtitle1">
            {text.length > maxLength ? `${text.slice(0, maxLength)}...` : text}
          </Typography>
        </Box>
      </Box>
    );
  };

  if (!daten) {
    return null;
  }

  return (
    <>
      {/* {isLoading ? (
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      ) : ( */}
      <div style={{ paddingTop: "10px", paddingBottom: "1px" }}>
        <Accordion
          sx={{
            backgroundColor: bg_color,
            boxShadow: "none",
            overflowWrap: "break-word",
          }}
          onChange={() => setNeuigkeiten(!neuigkeiten)}
          expanded={neuigkeiten}
        >
          <AccordionSummary expandIcon={<ArrowDownwardIcon />}>
            <AnnouncementIcon sx={{ marginTop: "5px", marginRight: "5px" }} color="white"></AnnouncementIcon>
            <Typography variant="h6">{t("Schwarzes Brett")}</Typography>
          </AccordionSummary>

          <AccordionDetails>
            <TableContainer
              style={{
                border: "none",
                boxShadow: "none",
                paddingLeft: "26px",
                paddingRight: "26px",
              }}
            >
              <Table>
                <TableHead>
                  <TableRow key="schwarzesbrett">
                    <CustomTableCell width="70%"></CustomTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {daten &&
                    daten
                      .sort((a, b) => {
                        // Datum Umwandeln und dann danach sortieren
                        const datumA = a.vondat.split(".").reverse().join("-");
                        const datumB = b.vondat.split(".").reverse().join("-");
                        return new Date(datumB) - new Date(datumA);
                      })
                      .map((item) => {
                        return (
                          <TableRow onClick={() => setShowMeldung(item.key)} key={item.key}>
                            <CustomTableCell>
                              <Accordion
                                style={{
                                  marginBottom: "0px",
                                  "&:before": {
                                    display: "none",
                                  },
                                }}
                              >
                                <Box>
                                  <Box display="block" width="100%">
                                    <Typography sx={{ paddingLeft: 1 }} color={mandantText} variant="subtitle2">
                                      {item.vondat}
                                    </Typography>
                                  </Box>

                                  <Box sx={{ padding: 2 }} display="flex" justifyContent="center" width="100%" height="100%">
                                    <Box sx={{ position: "absolute", top: -20, left: "50%", transform: "translateX(-50%)" }}>
                                      <IconButton disabled>
                                        <PushPin color="primary" />
                                      </IconButton>
                                    </Box>

                                    <Box flex={30}>
                                      <Typography variant="h6">{t(item.betreff)}</Typography>
                                    </Box>

                                    <Box flex={5} display="flex" justifyContent="flex-end">
                                      {item.datei && (
                                        <IconButton edge="end" onClick={(e) => openDatei(e, item.datei)}>
                                          <FolderOpenIcon color="primary" />
                                        </IconButton>
                                      )}
                                    </Box>

                                    <Box flex={1} sx={{ paddingLeft: 1, paddingRight: 1 }} display="flex" justifyContent="flex-end">
                                      <IconButton edge="end" onClick={() => setShowMeldung(item.key)}>
                                        <VisibilityIcon color="primary" />
                                      </IconButton>
                                    </Box>
                                  </Box>

                                  {shortText(item.meldung, 30)}

                                  <Typography sx={{ paddingLeft: 1 }} color={mandantText} variant="subtitle2">
                                    {item.mandant}
                                  </Typography>
                                </Box>

                                <Dialog open={showMeldung === item.key} onClose={(e) => closeMeldung(e)} fullWidth>
                                  <DialogTitle>
                                    <Typography variant="h4" component={"div"}>{t(item.betreff)} </Typography>
                                    {item.datei && (
                                      <IconButton edge="end" onClick={(e) => openDatei(e, item.datei)}>
                                        <FolderOpenIcon color="primary" />
                                      </IconButton>
                                    )}
                                  </DialogTitle>
                                  <DialogContent>
                                    <div style={{ border: "1px solid #ccc", padding: 10 }}>
                                      <HtmlEditor html={item.meldung}></HtmlEditor>
                                    </div>
                                    {/* <HtmlToText htmlText={item.meldung}></HtmlToText> */}
                                  </DialogContent>
                                  <DialogActions>
                                    <Button style={{ marginRight: "10px" }} color="primary" variant="contained" display="flex" onClick={(e) => closeMeldung(e)}>
                                      {t("Schließen")}
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                              </Accordion>
                            </CustomTableCell>
                          </TableRow>
                        );
                      })}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      </div>
      {/* )} */}
    </>
  );
}

export { SchwarzesBrett };
